import React from 'react';
import { Typeahead, TypeaheadComponentProps } from 'react-bootstrap-typeahead';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

// Custom Typeahead component with search icon
const TypeaheadWithIcon: React.FC<TypeaheadComponentProps> = (props) => {
    return (
        <>
            <Typeahead
                {...props}
                renderInput={({ inputRef, referenceElementRef, ...inputProps }) => (
                    <>
                        <label className='d-flex'>
                        <input
                            {...inputProps}
                            data-lpignore="true" 
                            data-1p-ignore="true"
                            autoComplete="off"
                            ref={(node) => {
                                inputRef(node);
                                referenceElementRef(node);
                                }}
                                className={`form-control form-control-input-custom`}
                            />
                        <FontAwesomeIcon
                            icon={faMagnifyingGlass}
                            className=""
                            style={{
                                pointerEvents: 'none',
                            }}
                            />
                        </label>
                    </>
                )}
            />
        </>
    );
};

export default TypeaheadWithIcon;